import { useEffect } from 'react';
import { useControls } from 'leva';

import { Flavor } from '../../../types';
import { cider } from './materials';

const useCiderColor = (flavor: Flavor) => {

  // const { color, metalness, roughness, transmission, opacity } = useControls({
  //   color: "#ff0000",
  //   metalness: { min: 0, max: 1, step: 0.01, value: 0 },
  //   roughness: { min: 0, max: 1, step: 0.01, value: 0 },
  //   transmission: { min: 0, max: 1, step: 0.01, value: 0.1 },
  //   opacity: { min: 0, max: 1, step: 0.01, value: 0.7 },
  // });

  // useEffect(() => {
  //   cider.color.set(color);
  //   cider.metalness = metalness;
  //   cider.roughness = roughness;
  //   cider.transmission = transmission;
  //   cider.opacity = opacity;
  // }, [color, metalness, roughness, transmission, opacity]);

  useEffect(() => {
    switch (flavor) {
      case "apple":
      case "elderflower":
        cider.color.set("#ff9900");
        cider.metalness = 0;
        cider.roughness = 0;
        cider.transmission = 0.01;
        cider.opacity = 0.6;
        break;
      case "blackberry":
        cider.color.set("#ff0026");
        cider.metalness = 0;
        cider.roughness = 0;
        cider.transmission = 0.1;
        cider.opacity = 0.9;
        break;
      case "blueberry":
        cider.color.set("#ff0000");
        cider.metalness = 0;
        cider.roughness = 0;
        cider.transmission = 0.1;
        cider.opacity = 0.9;
        break;
      case "mango":
        cider.color.set("#ff4d00");
        cider.metalness = 0;
        cider.roughness = 0;
        cider.transmission = 0.01;
        cider.opacity = 0.75;
        break;
      case "pear":
        cider.color.set("#ffe818");
        cider.metalness = 0;
        cider.roughness = 0;
        cider.transmission = 0.01;
        cider.opacity = 0.75;
        break;
      case "redrhubarb":
      case "watermelon":
        cider.color.set("#ff0000");
        cider.metalness = 0;
        cider.roughness = 0;
        cider.transmission = 0.01;
        cider.opacity = 0.75;
        break;
    }
  }, [flavor]);

}

export default useCiderColor;